import { TierSearchBox } from "./TierSearchBox";
import { Box, Typography } from '@mui/material';

import { ModelTier } from '../models/ModelTier';

import { useData } from '../hooks/DataProvider';


const TierSelectBox = ({ model, data, updateData, type, size = 3, forDocument = false }) => {

    const { language } = useData();

    const color = '#00000099'

    const fontSize = {fontSize: '.9rem'}
    return (
        <>

            {size === 1 &&
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }} >
                    <Box sx={{ display: 'flex', gap: 2 }} >
                        <TierSearchBox data={data} update={updateData} filed={type} forDocument={forDocument} />
                        {/* <Typography variant='subtitle1' color={color} sx={{ fontSize: '1.rem' }} > {model[type][language]} : </Typography> */}
                    </Box>
                    <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: '.5fr .3fr 2fr', alignItems: 'center' }} >
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} > {data?.[type]?.['code']} </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} > {data?.[type]?.['countryCode']} </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} > {data?.[type]?.['name']} </Typography>

                    </Box>
                </Box>
            }

            {size === 2 &&
                <Box sx={{ display: 'grid', gap: 0, gridTemplateColumns: '1.8fr 3fr', alignItems: 'center' }} >
                    <Box sx={{ display: 'flex', gap: 2 }} >
                        <TierSearchBox data={data} update={updateData} filed={type} forDocument={forDocument} />
                        <Typography variant='subtitle1' color={color} sx={{ fontSize: '1.rem' }} > {model[type][language]} : </Typography>
                    </Box>
                    <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: '.5fr .3fr 2fr', alignItems: 'center' }} >
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} > {data?.[type]?.['code']} </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} > {data?.[type]?.['countryCode']} </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} > {data?.[type]?.['name']} </Typography>
                    </Box>
                </Box>
            }

            {size === 3 &&
                <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: '.9fr 3fr', alignItems: 'center' }} >
                    <Box sx={{ display: 'flex', gap: 2 }} >
                        <TierSearchBox data={data} update={updateData} filed={type} forDocument={forDocument} />
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} > {model[type][language]} : </Typography>
                    </Box>
                    <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: '1.4fr 1.4fr 1fr .4fr 1.3fr' }} >
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} noWrap > {data?.[type]?.['code']} </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} noWrap> {data?.[type]?.['name']} </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} noWrap> {data?.[type]?.['countryCode']} - {data?.[type]?.['country']}</Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} noWrap> {data?.[type]?.['zipCode']} </Typography>
                        <Typography variant='subtitle1' sx={{ fontSize: '1.rem' }} noWrap > {data?.[type]?.['city']} </Typography>
                    </Box>
                </Box>
            }

            {size === 4 &&
                <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: '.2fr 4fr', alignItems: 'center' }} >
                    <Box sx={{ display: 'flex', gap: 2 }} >
                        <TierSearchBox data={data} update={updateData} filed={type} forDocument={forDocument} />
                    </Box>

                    {data?.[type]?.['name'] && <Box >

                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 2 }} >

                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }} >
                                 <Typography variant='subtitle1' sx={{ ...fontSize, fontWeight:500 }} noWrap>  {ModelTier.name[language]} : {data?.[type]?.['name']} </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }} >
                                <Typography variant='subtitle1' sx={{ ...fontSize }} noWrap>  {ModelTier.address[language]} : {data?.[type]?.['address']} </Typography>
                                <Typography variant='subtitle1' sx={{ ...fontSize }} noWrap>  {ModelTier.address2[language]} : {data?.[type]?.['address2']} </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }} >
                                <Typography variant='subtitle1' sx={{ ...fontSize }} noWrap>  {ModelTier.city[language]} : {data?.[type]?.['zipCode']} {data?.[type]?.['city']} </Typography>
                                <Typography variant='subtitle1' sx={{ ...fontSize }} noWrap > {ModelTier.country[language]} :  {data?.[type]?.['country']} </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }} >
                                <Typography variant='subtitle1' sx={{ ...fontSize }} noWrap > {ModelTier.siret[language]} :  {data?.[type]?.['siret']} </Typography>
                                <Typography variant='subtitle1' sx={{ ...fontSize }} noWrap > {ModelTier.tva[language]} :  {data?.[type]?.['tva']} </Typography>

                            </Box>
                        </Box>

                    </Box>
                    }
                </Box>
            }

        </>
    );
}

export { TierSelectBox };
